import { render } from "./CreateNotifications.vue?vue&type=template&id=4fc534d4"
import script from "./CreateNotifications.vue?vue&type=script&lang=js"
export * from "./CreateNotifications.vue?vue&type=script&lang=js"

import exportComponent from "/home/saes/central_authentication/central_authentication_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__